import React, { Component } from 'react';
import { Row, Col, Button, Input } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Field } from 'redux-form';
import ReactDOM from 'react-dom';

import ConfirmActionModal from '../Common/confirmActionModal';
import { DisabledInputField, InputField } from '../Common/inputField';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import {
  isCPG, isOLG, isGGI, isLAP, isUSPrideMulti, isAPD, isVIP, isCCW, isGFD, isCT
} from '../../actions/root_url';
import { roundTo } from '../Common/NumberUtil';



class SetWeightModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      needsDelete: false,
      rowsToDelete: 0,
      finished: false,
      oldLoaded: 0,
      totalWt: 0,
      changed: false,
      weights: {
        rows: [],
        sortColumn: null,
        sortDirection: null,
      },
      changeStyle: false,
      confirmOpen: false,
      case: 'zeroWeight',
      selectedWeightIdx: 1,
      selectedWeight: '',
    };
  }

  componentDidMount() {
    if (this.props.invoice) {
      let rows = [];
      this.props.currentWeights.map((weight) => {
        rows.push({ Weight: weight });
      });

      const oldLoaded = rows.length;
      if (rows.length < this.props.totalLoaded) {
        const temp = rows.length;
        for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
          rows.push({ Weight: 0 });
        }
      }


      if ((parseFloat(this.props.totalLoaded) < rows.length)) {
      //   const rowsToDelete = rows.length - this.props.totalLoaded;
      //   this.setState({ needsDelete: true, rowsToDelete, oldLoaded });
        let replace = [];
        for(let i= 0; i< parseFloat(this.props.totalLoaded); i++) {
          replace.push(rows[i]);
        }
        rows = [...replace];
      }
      // } else {
      //   this.setState({ needsDelete: false, oldLoaded });
      // }
      const weights = { ...this.state.weights, rows };
      this.handleSetTotalWt(weights);
      this.setState({ weights });
    } else {
      this.props.fetchSalesOrderLineWeights(this.props.rowChosen);
    }
    ReactDOM.findDOMNode(this.refs['TotalWeight'].getRenderedComponent().myInput.refs.input).focus();
  }

  componentWillReceiveProps(nextProps) {
    // if ((parseFloat(nextProps.totalLoaded) < nextProps.salesOrderLineWeights.length) && !this.state.finished){
    //   const rowsToDelete = nextProps.salesOrderLineWeights.length - nextProps.totalLoaded;
    //   this.setState({ needsDelete: true, rowsToDelete });
    // } else {
    //   this.setState({ needsDelete: false });
    // }
    if (nextProps.totalWeight !== this.props.totalWeight) {
      this.setState({totalWt:(parseFloat(nextProps.totalWeight) || 0)});
      let avgWeight = (parseFloat(nextProps.totalWeight) || 0) / (parseFloat(this.state.weights.rows.length) || 1);
      avgWeight = avgWeight.toFixed(2);
      let remainNum = 0;
      if(isLAP || isUSPrideMulti || isAPD) {
        remainNum = roundTo(parseFloat(nextProps.totalWeight || 0) - avgWeight * this.state.weights.rows.length, 2);
      }
      this.state.weights.rows.map((r, index) => {
        if((isLAP || isUSPrideMulti || isAPD) && index == this.state.weights.rows.length-1 && remainNum != 0) {
          r.Weight = roundTo(parseFloat(avgWeight) + parseFloat(remainNum), 2);
        } else {
          r.Weight = avgWeight;
        }
      });
      if (isCCW || isGFD) {
        const { rows } = this.state.weights;
        const length = rows.length;
        let avgWeight = (parseFloat(nextProps.totalWeight || 0) / (parseFloat(length) * 100 / 100) || 1).toFixed(2);
        avgWeight = (Math.floor(avgWeight * 100) / 100).toFixed(2);
        const diff = (parseFloat(nextProps.totalWeight || 0)) - (avgWeight * length);
        rows.map(r => {
          r.Weight = avgWeight;
        });
        if (length > 0) {
          rows[length - 1].Weight = ((parseFloat(rows[length - 1].Weight || 0) + diff) || 0).toFixed(2);
        }
        this.setState({ weights: { rows }});
      }
    }
    if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights !== this.props.salesOrderLineWeights) {
      let tempWeights = [];

      nextProps.salesOrderLineWeights.map((weight) => {
        tempWeights.push({ Weight: weight });
      });

      if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
        let newWeights = [...tempWeights]; // .splice(0, parseInt(this.props.totalLoaded));
        let replace = [];
        for(let i= 0; i< this.props.totalLoaded; i++) {
          replace.push(newWeights[i]);
        }
        newWeights = [...replace];
        const weights = { ...this.state.weights, rows: newWeights };
        this.setState({ weights });
        this.handleSetTotalWt(weights);
      } else {
        const temp = tempWeights.length;
        for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
          tempWeights.push({ 'Weight': 0 });
        }
        const weights = { ...this.state.weights, rows: tempWeights };
        this.setState({ weights });
        this.handleSetTotalWt(weights);
      }
    }
  }

  componentWillUnmount() {
    if (!this.state.changed) {
      this.props.keepLoaded(this.props.oldLoaded || this.state.oldLoaded);
    }
    this.props.clearSalesOrderLineWeights();
  }

  fillWithLastValue() {
    let index = 0;
    const newWeights = { ...this.state.weights };

    for (var i = 0; i < this.state.weights.rows.length; i++) {
      if (this.state.weights.rows[i].Weight === 0) {
        index = i;
        break;
      }
    }

    if (index > 0) {
      const fillValue = this.state.weights.rows[index - 1].Weight;

      for (var i = index; i < this.state.weights.rows.length; i++) {
        newWeights.rows[i].Weight = fillValue;
      }
      this.handleSetTotalWt(newWeights);
      this.setState({ weights: newWeights });
    }
  }

  clearAllValues() {
    const newWeights = [...this.state.weights.rows];
    newWeights.map((row) => {
      row.Weight = 0;
    });

    const weights = { ...this.state.weights, rows: newWeights }
    this.setState({ weights, totalWt:0})
  }

  handleKeyPress = (event) => {
    if (event.charCode === 13 && this.state.selectedWeight) {
      event.preventDefault();
      // ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      const weights = { ...this.state.weights };

      if (this.state.selectedWeightIdx === this.state.weights.rows.length){
        weights.rows[this.state.selectedWeightIdx - 1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights})
      } else if (this.state.selectedWeightIdx) {
        weights.rows[this.state.selectedWeightIdx - 1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1), weights})
      } else {
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.handleFinish(); });
      }
    } else if (event.charCode === 13 && this.state.selectedWeightIdx === 0){
      this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.handleFinish(); });
    }
    this.handleSetTotalWt(this.state.weights)
  }

  handleSetTotalWt = (weights) => {
    if(isOLG || isGGI) {
      let totalWt = 0;
      weights.rows.map((row) => {
        if (row.Weight) {
          totalWt += parseFloat(row.Weight);
        }
      });
      this.setState({totalWt: parseFloat(totalWt).toFixed(2)});
    }
  }

  handleChange = (event) => {
    this.setState({ selectedWeight: event.target.value });
  }


  renderWeightsSubmit = () => {
    const confirmWeights = (this.state.selectedWeightIdx === 0) ? <Translate value="press_enter_to_confirm_weights" /> : '';
    return (
      <div>
        <Row style={{ paddingLeft: '50px' }}>
          <h3 style={{ paddingLeft: '18px' }}><Translate value="set_weights" /></h3>
          <Col sm={7}>
            <Input
              type="number"
              addonBefore={this.state.selectedWeightIdx || ''}
              name="selectedWeight"
              autoFocus={!isCT}
              value={this.state.selectedWeight}
              onChange={this.handleChange}
              disabled={this.state.needsDelete}
              onKeyPress={(event) => {
                this.handleKeyPress(event);
              }}
            />
          </Col>
        </Row>
        <Col><span style={{ color: 'green', paddingLeft: '28px' }}>{confirmWeights}</span></Col>
      </div>
    );
  }
  renderSetTotalWeights = () => {
    if(isOLG || isGGI) {
      return (
        <div>
          <Row style={{ paddingLeft: '50px' }}>
            <h3 style={{ paddingLeft: '18px' }}><Translate value="set_total_weight" /></h3>
            <Col sm={6}>
              <Field
                name='TotalWeight'
                ref='TotalWeight'
                withRef
                onKeyPress={(event) => {
                  if (event.charCode == 13 && this.props.totalWeight) {
                    this.handleFinish();
                  }
                }}
                component={(!this.state.needsDelete) ? InputField : DisabledInputField}
              />
            </Col>
          </Row>
        </div>
      );
    }
  }

  renderWeightInputs() {
    const { salesOrderLineWeightsIsLoading, salesOrderLineWeightsError } = this.props;
    if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) { return <Spinner className="marginTopStyle" /> }
    else if (salesOrderLineWeightsError) { return (<div className="alert alert-danger">{JSON.stringify(salesOrderLineWeightsError) }</div>); }

    const getRows = () => Data.Selectors.getRows(this.state.weights);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({ Idx: rowIdx+1 }, rows[rowIdx]);
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const weights = { ...this.state.weights, rows };
      this.setState({ weights });
    };

    const onRowClick = (rowIdx, row) => {
      this.setState({selectedWeight: row.Weight, selectedWeightIdx: row.Idx});
    };

    const handleRowUpdated = (e) => {
      const rows = getRows();
      const updated = { Weight: parseFloat(e.updated.Weight) };
      Object.assign(rows[e.rowIdx], updated);
      const weights = { ...this.state.weights, rows }
      this.setState({ weights });
      this.handleSetTotalWt(weights);
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const weights = Object.assign({}, this.state.weights, { sortColumn, sortDirection });
      this.setState({ weights });
    };

    // Custom Formatter component
    const DateFormatter = React.createClass({
      render() {
        if (this.props.value) {
          const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          const date = new Date(this.props.value)
          const index = dateMap.indexOf(date.toString().slice(4, 3));
          const localDate = index + date.toString().slice(8, 6);
          return <span>{date.toString().slice(4, 15)}</span>;
        }
        return <span className="label label-danger">-</span>;
      },
    });

    const that = this;
    const deleteFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              type="button"
              onClick={() => {
                const weights = that.state.weights;
                weights.rows.splice(this.props.dependentValues.Idx - 1, 1);
                const rowsToDelete = that.state.rowsToDelete - 1;
                if (rowsToDelete === 0) {
                  that.setState({ needsDelete: false, rowsToDelete , weights, finished: true });
                } else {
                  that.setState({ rowsToDelete, weights });
                }
              }}
            >X</Button>
          </span>
        );
      },
    });


    // Column difinition
    const ZeroFormatter = React.createClass({
      render() {
        if (this.props.value <= 0 && this.props.dependentValues.zeroFound) { return <div style={{backgroundColor:'yellow'}}>{this.props.value}</div>; }
        return <div>{this.props.value}</div>;
      },
    });

    const columns = [        {
      name: <Translate value="action" />,
      width: 60,
      resizable: true,
      filterable: true,
      getRowMetaData: (row, idx) => ({ ...row, idx }),
      formatter: (props) => {
        return (<div
          onClick={() => {
            const rows = [...this.state.weights.rows];
            rows.splice(props.dependentValues.Idx - 1, 1);
            this.setState({
              weights: {
                ...this.state.weights,
                rows,
              }
            })
          }}
          style={{ textDecoration: 'underline', width: '100%', textAlign: 'center' }}
          >remove</div>)
      },
    },
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Weight',
        name: <Translate value="weight" />,
        width: 100,
        resizable: true,
        filterable: true,
        editable: true,
        formatter: ZeroFormatter,
        getRowMetaData: row => row,
      },
    ];
    const delColumns = [
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: false,
        filterable: true,
      },
      {
        key: 'Weight',
        name: <Translate value="weight" />,
        width: 100,
        resizable: true,
        filterable: true,
      },
      {
        key: 'Delete',
        name: <Translate value="" />,
        width: 60,
        formatter: deleteFormatter,
        getRowMetaData: row => row,
      },
    ];
    return (
      <Row>
        <Col sm={6}>
          <div style={{ maxWidth: '99%' }}>
            {
              (!this.state.needsDelete) ?
                <div id="SetWeightModal-dataGrid1">
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    onGridSort={handleGridSort}
                    columns={columns}
                    enableCellSelect={true}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                    onRowClick={onRowClick}
                    onRowUpdated={handleRowUpdated}
                    disable
                  />
                </div> :
                <div id="SetWeightModal-dataGrid2">
                  <span style={{ color: 'red' }}>DELETE {this.state.rowsToDelete} ROW(S)</span>
                  <ReactDataGrid
                    style={{ height: '10%' }}
                    onGridSort={handleGridSort}
                    columns={delColumns}
                    enableCellSelect={true}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    minHeight={275}
                    onRowUpdated={handleRowUpdated}
                  />
                </div>
            }
          </div>
        </Col>
        <Col sm={6}>
          <button className="btn btn-primary col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.fillWithLastValue(); }}><Translate value="fill_with_latest_value" /></button>
          <br />
          <br />
          <button className="btn btn-danger col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.clearAllValues(); }}><Translate value="clear_all_values" /></button>
          <br />
          <br />
          {this.renderWeightsSubmit()}
          {this.renderSetTotalWeights()}
        </Col>
      </Row>
    );
  }

  openConfirm = () => this.setState({ confirmOpen: true });

  closeConfirm = () => this.setState({ confirmOpen: false, zeroInList: false });

  isZeroWeight = (weights) => {
    let weightChecker = false;
    const zeroRows = { ...this.state.weights };
    for (let i = 0; i < weights.length; i++) {
      if (parseFloat(weights[i].Weight) <= 0) {
        zeroRows.rows[i].zeroFound = true;
        this.setState({ zeroInList: true, weights: zeroRows }, this.openConfirm());
        weightChecker = true;
      }
    }
    this.setState({ zeroInList: false });
    return weightChecker;
  }

  handleFinish = () => {
    if (!this.props.invoice) {
      if (!this.isZeroWeight(this.state.weights.rows)) {
        this.props.setOrderLineWeights(this.props.rowChosen, this.state.weights.rows, isGGI);
        let totalWeight = 0;
        const rows = [];
        this.state.weights.rows.map((row) => {
          if (row.Weight) {
            totalWeight += parseFloat(row.Weight);
            rows.push(parseFloat(row.Weight));
          }
        });
        if(isCCW && this.props.BinWeight !=-1 && totalWeight.toFixed(2) > this.props.BinWeight) {
          alert('The total weight cannot exceed the total weight of the batch')
          return
        }
        this.props.returnTotalWeight(totalWeight.toFixed(2), rows);
        this.setState({ changed: true }, () => { this.props.closeC(); });
      }
    } else {
      if (!this.isZeroWeight(this.state.weights.rows)) {
        this.props.setWeights(this.props.rowChosen, this.state.weights.rows, this.props.editedRow);
        let totalWeight = 0;
        const rows = [];
        this.state.weights.rows.map((row) => {
          if (row.Weight) {
            totalWeight += parseFloat(row.Weight);
            rows.push(parseFloat(row.Weight));
          }
        });
        if(isCCW && this.props.BinWeight != -1 && totalWeight.toFixed(2) > this.props.BinWeight) {
          alert('The total weight cannot exceed the total weight of the batch')
          return
        }
        this.props.returnTotalWeight(totalWeight.toFixed(2), rows);
        this.setState({ changeStyle: true, changed: true }, () => { this.props.closeC(); });
      }
    }
  }

  renderTotalWt =() => {
    if(isOLG || isGGI) {
      return<Col sm={3}>
      <span style={{ color: 'black', paddingLeft: '20px' }}>{this.state.totalWt}</span>
    </Col>
    } else {
      return<Col sm={3}>
            <Field
              name='TotalWeight'
              ref='TotalWeight'
              withRef
              onKeyPress={(event) => {
                if (event.charCode == 13 && this.props.totalWeight) {
                  this.handleFinish();
                }
              }}
              component={(!this.state.needsDelete) ? InputField : DisabledInputField}
            />
          </Col>
    }
  }

  render() {
    const createDialogStyle = {
      height: '200px',
      marginTop: '-20%',
      width: '300px',
      marginLeft: '-10%',
      left: '45%',
    };
    const confirmAction = (<Translate value="confirm_action" />);

    const { rows } = this.state.weights;
    let totalNetWeight = 0;
    rows.map((r) => {
      totalNetWeight += parseFloat(r.Weight) || 0;
    });
    return (
      <ContentWrapper>
        <hr />
        {this.renderWeightInputs()}
        <br />
        {
          (isCPG || isVIP) &&
          <Row>
            <Col sm={3}><label><Translate value="total_weight" />: </label></Col>
            <Col sm={3}>{totalNetWeight.toFixed(2)}</Col>
          </Row>
        }
        <Row>
          { isCCW && this.props.BinWeight != -1 ? <Col sm={3}><label><Translate value="total_weight" /> / {this.props.BinWeight}</label></Col>
          :
            (isCPG || isVIP) ?
              <Col sm={3}><label><Translate value="set_total_weight" /></label></Col>
            :
              <Col sm={3}><label><Translate value="total_weight" /></label></Col>
          }
          {this.renderTotalWt()}
        </Row>
        <br />
        {
          (!this.props.invoice) ?
            <div>
              <Row>
                <button className="btn btn-primary col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.handleFinish(); }}><Translate value="save_weights" /></button>
              </Row>
              <br />
              <Row>
                <button className="btn btn-danger col-sm-11 buttonStyle" type="button" disabled={this.state.needsDelete} onClick={() => { this.props.closeC(); }}><Translate value="discard_changes" /></button>
              </Row>
            </div> :
            <div>
              <Row>
                <button className={(this.state.changeStyle) ? "btn btn-success col-sm-11 buttonStyle" : "btn btn-primary col-sm-11 buttonStyle"} type="button" disabled={this.state.needsDelete} onClick={() => { this.handleFinish(); }}><Translate value="load_weights" /></button>
              </Row>
              <br />
              <Row>
                <button className="btn btn-danger col-sm-11 buttonStyle" type="button" onClick={() => { this.props.closeC(); }}><Translate value="close" /></button>
              </Row>
            </div>
          }
        <br />
        <Row>
          {/*
            {this.props.editSalesOrderLineWeightsError &&
            <div className="alert alert-danger">{this.props.editSalesOrderLineWeightsError}</div>}
            { (!this.props.invoice) ?
              <div>
                {this.props.salesOrderLineWeightsIsEditing &&
                <div className="alert alert-info"><Translate value="uploading" /></div>}
                {this.props.editSalesOrderLineWeightsSuccess &&
                <div className="alert alert-success"><Translate value="saved" /></div>}
              </div> :
              <span></span>
            }
          */}
        </Row>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm(); }} title={confirmAction}>
          <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default SetWeightModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Dispatch/setWeightModal.jsx